import React from "react";
import { EmojiHappyIcon } from "@heroicons/react/solid";
import HorizontalScroll from "react-horizontal-scrolling";
import { painting } from "../data";
import "../customcss.css";

export default function PaintingSlider() {
  return (
    <section id="hobbies" className="mx-auto place-content-center flex ">
      <div className="container px-5 py-10 mx-auto">
        <div className="text-center mb-20">
          <EmojiHappyIcon className="w-10 inline-block mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4">
            Hobbie
          </h1>
          <p classname="center">painting, sketching, game</p>
          <HorizontalScroll>
            {painting.map((painting) => (
              <img
                className="rounded w-56 h-64 object-cover"
                src={painting.src}
                alt={painting.alt}
              />
            ))}
          </HorizontalScroll>
        </div>
      </div>
    </section>
  );
}
